import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'

export const LARGE_DESKTOP_WHITESPACE_OFFSET = 64

export const SectionContainer = styled(Group)`
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  padding: ${rem(4)} ${rem(8)} ${rem(4)} ${rem(16)};

  @container (min-width: 640px) {
    padding: ${rem(4)} ${rem(12)} ${rem(12)} ${rem(20)};
  }

  &.saved-section {
    padding-bottom: ${rem(16)};

    @container (min-width: 640px) {
      padding-bottom: ${rem(20)};
    }
  }
`
